export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const LOG_OUT = 'LOG_OUT'



// WEBPACK FOOTER //
// ./src/store/mutations.js